interface CourtSvgProps {
  w?: number;
  h?: number;
  indoor?: boolean;
}

export const CourtSvg = ({ w = 220, h = 360, indoor = true }: CourtSvgProps) => (
  <svg viewBox="0 0 220 360" width={w} height={h} className="court-svg">
    <rect className="court-bg" x="0" y="0" width="220" height="360" rx="14"
      style={{ fill: indoor ? "#2a5d3a" : "#3b6a7a" }} />
    <rect className="court-line" x="14" y="14" width="192" height="332" rx="4" />
    <line className="court-line" x1="14" y1="120" x2="206" y2="120" />
    <line className="court-line" x1="14" y1="240" x2="206" y2="240" />
    <line className="court-line" x1="110" y1="120" x2="110" y2="240" />
    <line className="court-net"  x1="0"  y1="180" x2="220" y2="180" />
  </svg>
);

export const HeroCourt = () => (
  <svg viewBox="0 0 480 280" width="100%" height="100%"
    preserveAspectRatio="xMidYMid slice" className="court-svg">
    <rect className="court-bg" x="0" y="0" width="480" height="280" />
    <rect className="court-line" x="40" y="30" width="400" height="220" />
    <line className="court-line" x1="40" y1="100" x2="440" y2="100" />
    <line className="court-line" x1="40" y1="180" x2="440" y2="180" />
    <line className="court-line" x1="240" y1="100" x2="240" y2="180" />
    <line className="court-net"  x1="40" y1="140" x2="440" y2="140" />
    <circle cx="320" cy="160" r="5" fill="#d4ff3a" />
  </svg>
);
